<!--
cart
root component
AT
15.06.21
-->

<svelte:window
	on:dataUpdated={getData}
	on:cartUpdated={getData}
/>

<script>
	import SvgSprite from '../_shared/components/svg-sprite.svelte'
	import Client from './components/client.svelte'
	import ArbitraryOrderable from './components/arbitrary-orderable.svelte'

	export let data = {
		'cart': { 'orderables':[], 'price':0, 'order_price_min':0, 'quantity':0, 'approximative': '', 'isOrderable':false },
		'user': { 'roles':[] },
		}

	function getData(e){
//console.log('cart:getData() e.detail: ',e.detail)
		switch(e.type) {
			case 'dataUpdated':
				data = e.detail
				data.cart = data.cart || {}
				data.user = data.user || { 'roles':[] }
			break
			case 'cartUpdated':
				data.cart = e.detail || {}
		}

		data.client = data.client || { }

		//transforming { {}, {}, ... } to array [ {}, {}, ... ]
		//data.orderables = Object.keys(data.orderables).map((key) => data.orderables[key])

		//console.log('cart:getData:data:',data)

	}

	function set(orderable,quantity){
		orderable.quantity = quantity
		window.Cart.set(orderable)
	}

//console.log('data.orderables:',data.orderables)
//console.log('checkout:', window.location.href.indexOf('checkout') )

</script>

{ #if data.cart.orderables.length > 0 }
<table>
	<thead>
		<tr>
			<td>Товар</td>
			<td>Брэнд</td>
			<td class="centered">Цена</td>
			<td>Кол-во</td>
			<td></td>
			<td></td>
			<td></td>
		</tr>
	</thead>
	<tbody>
	{ #each data.cart.orderables as orderable (orderable.uid) }
		<tr>
			<td>
				<div class="flex flex-middle">
				{ #if orderable.image_link }
					<img src="{orderable.image_link}" class="cart-image">
				{ /if }
				{ orderable.name }
				</div>
			</td>
			<td>
				{ orderable.brand || '' }
				{ #if orderable.brand && orderable.donor }
					/
				{ /if }
				{ orderable.donor || ''}
			</td>
			<td class="centered cart-price">
				{ #if orderable.price && orderable.type=='product' }
					~
				{ /if }
				{ #if orderable.price && orderable.price !== NaN }
					{ orderable.price } ₽
				{ :else }
					call
				{ /if }
			</td>
			<td>
				<input
					type=number
					value={ orderable.quantity }
					min={ orderable.min_quantity || 0 }
					class="cart-quantity"
					on:change={ set(orderable,this.value) }>
			</td>
			<td>
				{ #if orderable.price && orderable.price !== NaN }
					{ Math.round( 100 * orderable.price * orderable.quantity, 2)/100 } ₽
				{ /if }
			</td>
			<td class="centered">
				<a class="L" on:click={ set(orderable,0) }>
					<!-- <SvgSprite symbol="cart-minus" css="L icon"/> -->
					✕
				</a>
			</td>
		</tr>
	{ /each }
	</tbody>
</table>

{ :else }
	<p class="L centered">
	Пока что здесь пусто.
	</p>
{ /if }

{ #if data.user.roles.includes('manager') || data.user.roles.includes('superuser') }
	<Client data={ data }/>
	<ArbitraryOrderable/>
{ /if }

<div class="flex flex-middle">
	<div class="XL padded">
	{ #if data.cart.quantity>0 }
		{ data.cart.quantity } шт.
	{ /if }
	{ #if data.cart.price>0 }
		/ { data.cart.approximative }{ data.cart.price } ₽
	{ /if }
	</div>

	<div class="padded flex-end">
	{ #if data.cart.isOrderable && window.location.href.indexOf('checkout')==-1 }
		<a href="/checkout" class="button">Оформить заказ</a>
	{ /if }
	{ #if !data.cart.isOrderable && data.cart.orderables.length>0 }
		Оформление заказа возможно от { data.cart.order_price_min } ₽
	{ /if }
	</div>
</div>
